'use client';

import dynamic from 'next/dynamic';

// The maplibre-gl stack only downloads where a map shows. ssr:false because WebGL is browser-only.
export const PropertyLocationMap = dynamic(() => import('./PropertyLocationMap'), { ssr: false });
